// import React from "react";
// import { Animate } from "react-move";

// class AnimatedProgressProvider extends React.Component {
//   interval = undefined;

//   state = {
//     isAnimated: false
//   };

//   static defaultProps = {
//     valueStart: 0
//   };

//   componentDidMount() {
//     if (this.props.repeat) {
//       this.interval = window.setInterval(() => {
//         this.setState({
//           isAnimated: !this.state.isAnimated
//         });
//       }, this.props.duration * 1000);
//     } else {
//       this.setState({
//         isAnimated: !this.state.isAnimated
//       });
//     }
//   }

//   componentWillUnmount() {
//     window.clearInterval(this.interval);
//   }

//   render() {
//     return (
//       <Animate
//         start={() => ({
//           value: this.props.valueStart
//         })}
//         update={() => ({
//           value: [
//             this.state.isAnimated ? this.props.valueEnd : this.props.valueStart
//           ],
//           timing: {
//             duration: this.props.duration * 1000,
//             ease: this.props.easingFunction
//           }
//         })}
//       >
//         {({ value }) => this.props.children(value)}
//       </Animate>
//     );
//   }
// }

// export default AnimatedProgressProvider;

import React, { useState, useEffect } from "react";
import { Animate } from "react-move";

const AnimatedProgressProvider = (props) => {
  const [isAnimated, setIsAnimated] = useState(false);
  let interval = undefined;
  let timeout = undefined;

  useEffect(() => {
    if (props.repeat) {
      interval = setInterval(() => {
        setIsAnimated(!isAnimated);
      }, props.duration * 1000);
    } else if (props.rowSkillMouseEnter) {
      timeout = setTimeout(() => {
        setIsAnimated(true);
      }, props.delay);
    } else {
      setIsAnimated(props.mouseEnter);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [props.mouseEnter, props.rowSkillMouseEnter]);

  return (
    <Animate
      start={() => ({
        value: props.valueStart
      })}
      update={() => ({
        value: [
          isAnimated ? props.valueEnd : props.valueStart
        ],
        timing: {
          duration: props.duration * 1000,
          ease: props.easingFunction,
        }
      })}
    >
      {({ value }) => props.children(value)}
    </Animate>
  );
};

AnimatedProgressProvider.defaultProps = {
  valueStart: 0
};

export default AnimatedProgressProvider;

